import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { toast } from "sonner";
import { errorMessage } from "../lib/errors";
import { Mail, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Bon retour, ${u.full_name.split(" ")[0]} !`);
      const redirect = params.get("redirect") || (u.is_admin ? "/admin" : "/dashboard");
      nav(redirect);
    } catch (err) {
      toast.error(errorMessage(err, "Connexion échouée"));
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <div className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-3">Bon retour</div>
      <h1 className="font-display text-4xl text-ink-900 mb-2">Se connecter</h1>
      <p className="text-muted2 text-sm mb-8">Heureux de vous revoir. Reprenons là où vous vous étiez arrêté(e).</p>

      <form onSubmit={submit} className="glass rounded-2xl p-6 space-y-4">
        <div>
          <label className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-1.5 block">Email</label>
          <div className="relative">
            <Mail className="w-4 h-4 absolute left-3 top-3.5 text-muted2" />
            <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="vous@email.com"
              className="w-full bg-white border border-gold-200 rounded-lg pl-10 pr-3 py-3 text-ink-900 placeholder:text-ink-400 focus:outline-none focus:border-gold-400"
              data-testid="login-email-input" />
          </div>
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-1.5 block">Mot de passe</label>
          <div className="relative">
            <Lock className="w-4 h-4 absolute left-3 top-3.5 text-muted2" />
            <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="••••••••"
              className="w-full bg-white border border-gold-200 rounded-lg pl-10 pr-3 py-3 text-ink-900 placeholder:text-ink-400 focus:outline-none focus:border-gold-400"
              data-testid="login-password-input" />
          </div>
        </div>
        <button type="submit" disabled={busy}
          className="w-full px-5 py-3 rounded-full bg-gold-500 text-ink-900 font-medium hover:bg-gold-500-400 shadow-gold disabled:opacity-60"
          data-testid="login-submit-button">
          {busy ? "Connexion…" : "Se connecter"}
        </button>
        <div className="flex justify-between text-xs text-muted2 pt-1">
          <Link to="/forgot-password" className="hover:text-gold-700-700" data-testid="forgot-password-link">Mot de passe oublié ?</Link>
          <Link to="/register" className="hover:text-gold-700-700" data-testid="login-to-register-link">Créer un compte →</Link>
        </div>
      </form>

      <div className="mt-6 text-xs text-muted2 leading-relaxed glass rounded-xl p-4">
        <div className="text-gold-700 uppercase tracking-widest font-mono mb-2">Comptes de démonstration</div>
        <p><strong className="text-ink-900">Utilisateur</strong> : demo@ecs-demo.io / DemoECS2026!</p>
        <p><strong className="text-ink-900">Admin</strong> : admin@ecs-demo.io / AdminECS2026!</p>
      </div>
    </div>
  );
}
